export enum MemberType {
  USER = "USER",
  ADMIN = "ADMIN",
}

export enum MemberStatus {
  ACTIVE = "ACTIVE",
  BLOCK = "BLOCK",
  DELETE = "DELETE",
}
